import type { ReactNode } from "react";

export function EmptyState({
  title,
  description,
  children,
}: {
  title: string;
  description: string;
  children?: ReactNode;
}) {
  return (
    <div className="rounded-lg border border-muted bg-surface/40 p-10 text-center">
      <p className="text-[16px] font-medium text-foreground">{title}</p>
      <p className="mx-auto mt-1 max-w-sm text-sm text-foreground/70">
        {description}
      </p>
      {children && <div className="mt-4 flex justify-center">{children}</div>}
    </div>
  );
}
